import { STORAGE_USER_ID } from "../constants/localstorage";
import { getRoom } from "../libs/hooks";
import { getStorage } from "../libs/storage";
import { ChannelAddMemberResponse } from "../proto/ChannelAddMember_pb";
import { ChannelCreateResponse } from "../proto/ChannelCreate_pb";
import { GroupAddMemberResponse } from "../proto/GroupAddMember_pb";
import { GroupCreateResponse } from "../proto/GroupCreate_pb";
import store from "../store";
import { addRoomMembers } from "../store/rooms/actions";
import BaseHandler from "./BaseHandler";

export default class HandleRoomAddMemberResponse extends BaseHandler<ChannelAddMemberResponse | GroupAddMemberResponse | ChannelCreateResponse | GroupCreateResponse> {
  handle() {
    const roomAddMemberResponse = this.response.toObject();
    if (!("userId" in roomAddMemberResponse) || roomAddMemberResponse.userId === getStorage(STORAGE_USER_ID)) {
      getRoom(roomAddMemberResponse.roomId).then();
    } else if ("userId" in roomAddMemberResponse) {
      store.dispatch(
        addRoomMembers({
          roomId: roomAddMemberResponse.roomId,
          memberList: [
            {
              role: roomAddMemberResponse.role,
              userid: roomAddMemberResponse.userId,
            },
          ],
        })
      );
    }
  }
}
